<template>
	<header class="bg-white">
		<div class="flex w-full flex-col gap-8 px-5 pb-[60px] pt-6 2xl:px-32">
			<div>
				<Breadcrumb :items="breadcrumbItems" />
			</div>
			<div>
				<h1
					class="font-matter-sq text-2xl font-normal leading-[150%] tracking-[-0.72px] text-primary md:text-4xl"
				>
					Práticas e compromissos para sua segurança
				</h1>
				<h2 class="text-base leading-[150%] text-primary md:text-lg">
					Conheça as diretrizes que regem o uso de nossa plataforma.
				</h2>
			</div>
		</div>
	</header>
	<article class="min-h-screen bg-white-dark-1! px-6 py-[60px] 2xl:px-0">
		<Container
			class="h-full max-w-4xl bg-white! shadow-[0px_1px_3px_1px_rgba(0,0,0,0.15)]"
		>
			<iframe src="/termos/termo-de-uso-b2c" class="h-screen w-full" />
		</Container>
	</article>
</template>

<script setup lang="ts">
import { defaultTwitterCardMeta } from '@/constants/seo';
import { useAbsoluteUrl } from '~/composables/useAbsoluteUrl';

const breadcrumbItems = [
	{ label: 'Início', route: '/' },
	{
		label: 'Termos de uso',
		route: '/termos-de-uso'
	}
];

const route = useRoute();

const mixpanel = useMixpanel();

const { toAbsoluteUrl } = useAbsoluteUrl();
const ogImageUrl = toAbsoluteUrl('/images/social/openGraph/og_home.webp');

useSeoMeta({
	title: 'Termos e condições de Uso | PilarHomes',
	description:
		'Práticas e compromissos para sua segurança. Conheça os termos de uso do PilarHomes e aproveite a confiança que você merece em cada transação.',
	keywords: 'termos de uso, PilarHomes',
	ogTitle: 'Termos e condições de Uso | PilarHomes',
	ogDescription:
		'Práticas e compromissos para sua segurança. Conheça os termos de uso do PilarHomes e aproveite a confiança que você merece em cada transação.',
	ogImage: ogImageUrl,
	twitterCard: defaultTwitterCardMeta,
	twitterTitle: 'Termos e condições de Uso | PilarHomes',
	twitterDescription:
		'Práticas e compromissos para sua segurança. Conheça os termos de uso do PilarHomes e aproveite a confiança que você merece em cada transação.',
	twitterImage: ogImageUrl
});

onMounted(() => {
	mixpanel.track('page_viewed', {
		current_page: route.fullPath,
		previous_page_url: document.referrer,
		event_name: 'page_viewed'
	});
});
</script>
